export default __webpack_public_path__ + "static/top-mobile-bcc45abeafaa26808437ba2e3d1deee2.png";